import { render, staticRenderFns } from "./AppTimelineItem.vue?vue&type=template&id=083fa4dc&scoped=true&"
import script from "./AppTimelineItem.vue?vue&type=script&lang=js&"
export * from "./AppTimelineItem.vue?vue&type=script&lang=js&"
import style0 from "./AppTimelineItem.vue?vue&type=style&index=0&id=083fa4dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083fa4dc",
  null
  
)

export default component.exports